import Button from 'components/shared/app/Button';
import { ProviderNames } from 'lib/data/models/Providers';
import UserService from 'lib/services/UserService';
import { copyToClipboard, getInnerError } from 'lib/utils/adaya/AdayaUtils';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './style.scss';

const TrackingId = ({ user, ...props }) => {
    const [tracking, setTracking] = useState();
    const [showSmallView, setShowSmallView] = useState(props.showSmallView);
    const [error, setError] = useState('');
    const [trackingDomains, setTrackingDomains] = useState('');
    const elInputDomains = useRef();

    const account = user?.activeAccount;

    // init tracking id
    useEffect(() => {
        if (account && account.tracking) {
            setTracking(account.tracking);
        }
    }, [user]);

    const generateTrackingId = async () => {
        try {
            // if (!trackingDomains) {
            //     return setError("Please enter at least one domain for this tracker.");
            // }

            let tracking = await UserService.getTrackingForAccount(user, account, trackingDomains);
            if (tracking) {
                // update the app user object:
                account.tracking = tracking;
                // todo: need better solution for updating tracking state... server should update new user.
                user.activeAccount.tracking = user.accounts[0].tracking = tracking;
                props.auth.updateUserLocal(user);
                setTracking(tracking);
            }
        } catch (e) {
            setError(getInnerError(e));
        }
    }

    const getEmbedScript = () => {
        let fbProvider = account.providers.find(p => p.name == ProviderNames.FACEBOOK);
        let fbPixelId = fbProvider?.data?.pixelId;
        const hasFbData = (account) => (fbProvider?.data?.pixelId && fbProvider?.data?.conversionAccessToken);

        return `<!-- Adaya Analytics -->
<script>` +

            (tracking?.trackingId ?
                `
    window.aa=window.aa||function(){(aa.q=aa.q||[]).push(arguments)};aa.l=+new Date;
    aa('create', '${tracking.trackingId}');
    aa('event', 'pageview');
` : ``) +

            (hasFbData(account) ?
                `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${fbPixelId}');
` : ``) +

            `</script>
` +

            (hasFbData(account) ?
                `<noscript>
    <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${fbPixelId}&ev=PageView&noscript=1"/>
</noscript>
` : ``) +

            `<script>
    window.aa.script = document.createElement('script');
    atScript.setAttribute('src', '${process.env.API_URL}/adtrack.js?v=' + (Math.floor(new Date().getTime()/1000/60/30)));
    document.head.appendChild(window.aa.script);
</script>
`+
            //<script async src='${process.env.API_URL}/adtrack.js'></script>
            `<!-- End Adaya Analytics -->`;
    }

    const copyTrackingEmbed = () => {
        copyToClipboard(getEmbedScript());
    }

    // const onChangeTrackingDomains = (v) => {
    //     setIsDirty(true);
    //     //setTrackingDomains(v);
    // }

    // const saveTracking = async () => {
    //     tracking.domains = trackingDomains;
    //     let tr = await UserService.updateTrackingForAccount(account, tracking, trackingDomains);
    //     setIsDirty(false);
    //     console.log('tracking updated', tr);
    // }

    return (
        <div className="tracking-id">

            {showSmallView &&
                <div className="small-view">

                    {!tracking && <div>Please generate a tracking ID from your Account page.</div>}

                    {tracking &&
                        <div className="tracking-id">
                            <h5>Account Tracking ID:</h5>
                            <h6>{tracking.trackingId}</h6>
                        </div>
                    }

                    <div className="get-embed">
                        <Button color="blue" round filled onClick={() => setShowSmallView(false)}>Get Embed Code</Button>
                    </div>
                </div>
            }

            {!showSmallView &&
                <div className="normal-view flex-col">

                    <div className="header">

                        <div className="create-tracking-id">

                            {tracking &&
                                <div className="tracking-id">
                                    <h5>Account Tracking ID:</h5>
                                    <h6>{tracking.trackingId}</h6>
                                </div>
                            }

                            {false &&
                                <div className="domains margin sm ns">

                                    <div className="label margin sm ns">
                                        Enter the domains for which this tracking will be used, separated by commas:
                                    </div>

                                    <div className="cols">

                                        <div className="col">
                                            <textarea rows="3" className="input input-domains dark" width="300" placeholder="https://firststore.com, https://secondstore.com"
                                                value={trackingDomains}
                                                onChange={(e) => onChangeTrackingDomains(e.target.value)}
                                            />
                                        </div>

                                        <div className="col padding md ntb">
                                            {isDirty && tracking && <Button color="blue" round filled onClick={() => saveTracking()}>Save</Button>}
                                        </div>

                                    </div>

                                </div>
                            }

                            {!tracking &&
                                <Button className="margin sm ns" color="blue" round filled onClick={generateTrackingId}>
                                    Generate Tracking ID
                                </Button>
                            }

                        </div>

                    </div>

                    {tracking && tracking.trackingId &&
                        <div className="margin md ns flex-col">
                            Copy this script and place it at the bottom of your site's homepage to begin tracking on your website for this ad account.
                            <textarea className="margin md ns" rows="8" cols="80" style={{ fontSize: '.85rem' }} readOnly value={getEmbedScript()}></textarea>
                            <Button className="btn-copy" color="blue" round filled onClick={copyTrackingEmbed}>Copy to Clipboard</Button>
                        </div>
                    }

                    {tracking && user.roles.includes('admin') &&
                        <div className="view-stats font-plain-large">
                            <Link to="/ads-manager"><Button round filled color="blue">View Reports</Button></Link>
                        </div>
                    }

                    {/* <div className="hide-embed">
                            <Button color="blue" round filled onClick={() => setShowSmallView(true)}>Hide Embed Code</Button>
                        </div> */}

                    {error != '' && <div className="status error margin sm ns">{error}</div>}

                </div>
            }

        </div>

    );

}

export default TrackingId;


